<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>傳送訊息紀錄</h3>
          <hr />
        </div>
      </div>
    </div>
    <el-row :span="24">
      <el-col :span="24">
        <el-button
          type="primary"
          @click="openMessageDialog"
          icon="el-icon-message"
        >
          發送訊息
        </el-button>
        <el-button type="info" @click="setDefaultMsg">設定預設訊息</el-button>
        <el-button type="warning" @click="setDefaultDriverMsg">
          設定司機預設罐頭訊息
        </el-button>
      </el-col>
      <el-col :span="24" style="margin-top: 2rem">
        <span style="font-size: 2rem">起始時間：</span>
        <el-date-picker
          v-model="startTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          placeholder="選擇起始時間"
          :picker-options="pickerOptionStartTime"
        ></el-date-picker>
        <span style="font-size: 2rem; margin-left: 1rem">結束時間：</span>
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          placeholder="選擇結束時間"
          :picker-options="pickerOptionEndTime"
        ></el-date-picker>
      </el-col>
      <el-col :span="24" style="margin-bottom: 2rem">
        <el-col class="search-item">
          <h4>查詢關鍵字：</h4>
          <el-tooltip
            content="關鍵字需輸入兩個字以上"
            placement="bottom"
            effect="light"
          >
            <el-input
              placeholder="訊息內容、呼號"
              v-model.trim="searchCallNumber"
            ></el-input>
          </el-tooltip>
          <el-button
            type="success"
            :loading="isSearchBtnLoading"
            @click="onSearch"
          >
            搜尋
          </el-button>
        </el-col>
        <small>小提示：</small>
        <ol>
          <li>
            <small>
              日期區間最多設定一年 (避免系統當機)，預設顯示3天內的資料
            </small>
          </li>
          <li>
            <small>★ 代表重要訊息</small>
          </li>
        </ol>
      </el-col>
    </el-row>
    <div class="row">
      <select
        @change="getList(1)"
        v-model="selectValue"
        name="datatable-checkbox_length"
        aria-controls="datatable-checkbox"
        class="fontSize20"
      >
        <option
          v-for="npp in ['10', '25', '50', '100']"
          :key="npp"
          :value="npp"
        >
          {{ npp }}
        </option>
      </select>
      <DriverMessageList
        ref="pagination"
        :messageList="messageList"
        :pagination="pagination"
        @updateData="getList"
      />
    </div>
    <div
      id="driverMessage"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fontSize16" id="exampleModalLabel">
              司機罐頭預設訊息
            </h1>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div
            class="margin-input col-md-12"
            v-for="(item, key) in 10"
            :key="key"
          >
            <label class="fontSize14 col-md-2 col-sm-2 col-xs-2">
              預設 {{ key + 1 }}
            </label>
            <input
              type="text"
              class="inputstyle fontSize14 col-md-9 col-sm-9 col-xs-9"
              v-model="driverMsg[key].message"
            />
          </div>
          <button
            type="button"
            class="btn mybtnstyle btn-dark white_textcolor"
            @click="updateDriverMsg"
          >
            儲存
          </button>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="message"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title" id="exampleModalLabel">預設訊息</h1>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div
            class="margin-input col-md-12"
            v-for="(item, key) in 30"
            :key="key"
          >
            <label class="fontSize14 col-md-2 col-sm-2 col-xs-2">
              預設{{ key + 1 }}
            </label>
            <input
              type="text"
              class="inputstyle fontSize14 col-md-9 col-sm-9 col-xs-9"
              v-model="msg[key].message"
            />
          </div>
          <button
            type="button"
            class="btn mybtnstyle btn-dark white_textcolor"
            @click="updateDefaultMsg"
          >
            儲存
          </button>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
    <MessageDialog ref="messageDialog"></MessageDialog>
  </div>
</template>
<script>
import {
  reqMsgList,
  reqDefaultMsg,
  reqDefaultDriverMsg,
  reqUpdateMsg,
  reqUpdateDriverMsg,
} from '@/api/driverMsg'
import dayjs from 'dayjs'
import { Notification } from 'element-ui'
import DriverMessageList from '@/components/hailState/DriverMessageList'
import MessageDialog from './MessageDialog'

export default {
  components: {
    DriverMessageList,
    MessageDialog,
  },
  name: 'MessageList',
  data() {
    return {
      messageList: [],
      searchCallNumber: '',
      selectValue: 10,
      pagination: {},
      startTime: dayjs().subtract(3, 'day'),
      endTime: dayjs(),
      isSearchBtnLoading: false,
      /* 訊息 */
      msg: Array.from({ length: 30 }, () => ({ message: null })),
      defaultMsg: [],
      /* 司機訊息 */
      driverMsg: Array.from({ length: 10 }, () => ({ message: null })),
      defaultDriverMsg: [],
    }
  },
  methods: {
    openMessageDialog() {
      this.$refs.messageDialog.openDialog()
    },
    hide(val) {
      this.$router.push({ name: 'MessageDetail', params: { id: val } })
    },
    async setDefaultDriverMsg() {
      try {
        const { result } = await reqDefaultDriverMsg()
        if (result) {
          const messageList = JSON.parse(result)
          for (let i = 0; i < messageList.length; i++) {
            this.driverMsg[i].message = messageList[i].message
          }
          $('#driverMessage').modal('show')
        } else {
          Notification({
            type: 'warning',
            message: '找不到資訊',
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    async setDefaultMsg() {
      try {
        const { result } = await reqDefaultMsg()
        if (result) {
          const messageList = JSON.parse(result)
          for (let i = 0; i < messageList.length; i++) {
            this.msg[i].message = messageList[i].message
          }
          $('#message').modal('show')
        } else {
          Notification({
            type: 'warning',
            message: '找不到資訊',
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getList(current_page = 1) {
      try {
        this.isSearchBtnLoading = true
        const startTimeFormat = dayjs(this.startTime)
          .subtract(8, 'hour')
          .format('YYYY-MM-DD HH:mm:ss')
        const endTimeFormat = dayjs(this.endTime)
          .subtract(8, 'hour')
          .format('YYYY-MM-DD HH:mm:ss')
        const {
          result: { data, paging },
        } = await reqMsgList({
          start_date: startTimeFormat,
          end_date: endTimeFormat,
          current_page: current_page,
          per_page: this.selectValue,
          kw: this.searchCallNumber,
        })
        this.messageList = data.map((row) => {
          row.postTime = dayjs(row.postTime).format('YYYY-MM-DD HH:mm:ss')
          return row
        })
        this.pagination = paging
      } catch (e) {
        console.error(e)
      } finally {
        this.isSearchBtnLoading = false
      }
    },
    getNpp(val) {
      this.npp = val
      this.getList()
    },
    getPage(val) {
      this.page = val
      this.getList()
    },
    onSearch() {
      if (this.searchCallNumber && this.searchCallNumber.length < 2) {
        Notification({
          type: 'warning',
          message: '關鍵字需輸入兩個字以上',
        })
        return
      }
      if (this.startTime > this.endTime) {
        Notification({
          type: 'warning',
          message: '日期設定錯誤，結束時間需大於開始時間',
        })
        return
      }
      this.getList()
    },
    async updateDefaultMsg() {
      try {
        for (let i = 0; i < this.msg.length; i++) {
          if (this.msg[i].message) {
            this.defaultMsg.push(this.msg[i].message)
          }
        }
        const { result } = await reqUpdateMsg({ message: this.defaultMsg })
        if (result) {
          Notification({
            type: 'success',
            message: '更新預設訊息成功',
          })
          this.defaultMsg = []
        } else {
          Notification({
            type: 'success',
            message: '更新預設訊息失敗',
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    async updateDriverMsg() {
      try {
        for (let i = 0; i < this.driverMsg.length; i++) {
          if (this.driverMsg[i].message) {
            this.defaultDriverMsg.push(this.driverMsg[i].message)
          }
        }
        const { result } = await reqUpdateDriverMsg({
          message: this.defaultDriverMsg,
        })
        if (result) {
          Notification({
            type: 'success',
            message: '更新司機預設訊息成功',
          })
          this.defaultDriverMsg = []
        } else {
          Notification({
            type: 'error',
            message: '更新司機預設訊息失敗',
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
  computed: {
    pickerOptionStartTime() {
      return {
        disabledDate(startTime) {
          const oneYearBeforeToday = dayjs().subtract(1, 'year')
          return dayjs(startTime).isBefore(oneYearBeforeToday)
        },
      }
    },
    pickerOptionEndTime() {
      return {
        disabledDate(endTime) {
          const today = dayjs()
          return dayjs(endTime).isAfter(today)
        },
      }
    },
  },
  mounted() {
    this.getList()
  },
}
</script>

<style scoped lang="scss">
button {
  margin-bottom: 0 !important;
  height: 40px;
}

.search-item {
  display: flex;
  margin: 1.5rem 0;

  h4 {
    display: inline;
  }

  .el-input {
    width: 300px;
  }

  button {
    margin: 0 15px;
  }
}

small {
  font-size: 14px;
  color: blue;
  display: inline;
}

.mybtnstyle {
  margin-bottom: 10px;
}

.margin-input {
  margin-bottom: 10px;
}

.table-font-size {
  font-size: 14px;
}

.column-title {
  text-align: center;
}

.subject {
  width: 30%;
}

.red_textcolor {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/message/MessageList.vue